<template>
  <div id="support-flow" class="pa-3">
    <!--タイトル-->
    <span class="subHead">
      制作の流れ
    </span>
    <v-icon class="mb-2" color="blue-grey darken-2">
      mdi-image-auto-adjust
    </v-icon>
    <!--タイムラインコンポーネントの挿入 for文で回す-->
    <v-timeline dense>
      <v-timeline-item
        v-for="(item, i) in steps"
        :key="i"
        small
        color="teal lighten-2"
      >
        <!--吹き出し-->
        <v-card class="elevation-2">
          <!--吹き出しのタイトル-->
          <v-card-title>Step{{ item.step }}</v-card-title>
          <!--内容-->
          <v-card-text class="text--primary">
            {{ item.content }}
          </v-card-text>
          <!--ボタン-->
          <v-card-actions v-if="item.hasButton">
            <v-spacer></v-spacer>
            <v-btn
            rounded
            outlined
            class="mx-2"
            color="primary"
            v-for="(btn, i) in item.button"
            :key="i"
            :href="btn.href">
            <v-icon class="ml-2">
                <!--ボタンの中のアイコン-->
                {{ btn.icon }}
              </v-icon>
              <!--ボタンの中の文字-->
              {{ btn.text }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>
<style>
.v-card__actions {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: block!important;
    padding: 8px;
}
.v-card__actions > .v-btn.v-btn {
    padding: 0 8px;
    margin-top: 0.5rem;
}
</style>

<script>
export default {
  data () {
    return {
      // タイムラインコンポーネントの内容
      steps: [
        {
          // Step1
          step: '1',
          // 内容
          content: 'お電話 088-625-8102 または Email： info@konniesystem.co.jp までご連絡ください。',
          // ボタンが必要かどうか
          hasButton: 'true',
          // ボタンの内容
          button: [
            {
              text: 'メールを送る',
              icon: 'mdi-email',
              href: 'mailto:info@konniesystem.co.jp'
            },
            {
              text: '電話をかける',
              icon: 'mdi-phone',
              href: 'tel:0886258102'
            }
          ]
        },
        {
          // Step2
          step: '2',
          // 内容
          content: '弊社より営業日3日以内にお見積りをお送りします。',
          // ボタンが必要かどうか
          hasButton: 'false'
        },
        {
          // Step3
          step: '3',
          // 内容
          content: 'ご検討をお願いします。',
          // ボタンが必要かどうか
          hasButton: 'false'
        },
        {
          // Step4
          step: '4',
          content: 'ページ制作を開始します。  ※掲載する画像や原稿・資料等をメールなどでお送りください。',
          // ボタンが必要かどうか
          hasButton: 'false'
        },
        {
          // Step5
          step: '5',
          // 内容
          content: 'デザインをサイト上でご確認後、ご指示頂きましたら修正を行います。',
          // ボタンが必要かどうか
          hasButton: 'false'
        },
        {
          // Step6
          step: '6',
          // 内容
          content: '本番サーバーに設置を行い、開設準備を行います。',
          // ボタンが必要かどうか
          hasButton: 'false'
        },
        {
          // Step7
          step: '7',
          // 内容
          content: 'ホームページ開設。',
          // ボタンが必要かどうか
          hasButton: 'false'
        },
        {
          // Step8
          step: '8',
          // 内容
          content: '費用のご請求をさせて頂き、学会開催終了までサイト運営のサポートを行います。',
          // ボタンが必要かどうか
          hasButton: 'false'
        }
      ]
    }
  }
}
</script>
